import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthService, SessionService } from '@app/core';
import { Account } from '@common/interfaces';


@Injectable()
export class LoggedOutGuard  {
  private _authService = inject(AuthService);
  private _sessionService = inject(SessionService);
  private _router = inject(Router);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const account: Account = this._sessionService.account();
    if (!this._sessionService.isExpired() && account) {
      return this._router.createUrlTree(['/']);
    }

    return true;
  }

}
